import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#0B4F3F] disabled:pointer-events-none disabled:opacity-50 active:scale-[0.97] [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#0B4F3F] text-[#F6F8FB] shadow-[0_4px_16px_-4px_rgba(11,79,63,0.35)] hover:bg-[#0E5D4A] hover:shadow-[0_6px_24px_-4px_rgba(11,79,63,0.5)]",
        destructive:
          "bg-[#DC2626] text-[#0B1620] shadow-sm hover:bg-[#FF7373]",
        outline:
          "border border-[#E4E8EF] bg-transparent text-[#0B1620] hover:bg-[#EFF2F7] hover:border-[#0B4F3F]/30",
        secondary:
          "bg-[#EFF2F7] text-[#0B1620] border border-[#E4E8EF] hover:bg-[#E4E8EF]",
        ghost: "text-[#0B1620] hover:bg-[#EFF2F7]",
        link: "text-[#0B4F3F] underline-offset-4 hover:underline rounded-none",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-12 px-8 text-base",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
